import { LineContainer } from './style';

const DashedLine = () => {
  return <LineContainer />;
};

export default DashedLine;
